import React, { useState } from "react";
import "./Badge.scss";

export type Type =
  | "mfg-primary"
  | "mfg-link"
  | "mfg-danger"
  | "mfg-success"
  | "mfg-normal";
export type size = "mfg-small" | "mfg-medium" | "mfg-large";

export interface Props {
  size?: size;
  type?: Type;
  customClass?: string;
  id?: any;
  onBadgerClick?: any;
  badgeLink?: any;
  badgeData: any;
  removeBadge?: any;
  removeVisible?: boolean;
  style?: React.CSSProperties;
}

const Badge = ({
  size = "mfg-small",
  type = "mfg-normal",
  customClass,
  id,
  onBadgerClick,
  badgeLink,
  badgeData,
  removeBadge,
  removeVisible,
  style = {},
}: Props) => {
  return (
    <div className={`mfg-badge${customClass ? " " + customClass : ""}`} id={id} style={style && style}>
      {badgeData && (
        <ul>
          {badgeData.map((item: any, index: number) => (
            <li key={item} className={`${size && size} ${type && type}`}>
              {badgeLink ? (
                <a href={badgeLink[index]}>{item}</a>
              ) : onBadgerClick ? (
                <button onClick={onBadgerClick}>{item}</button>
              ) : (
                <span>{item}</span>
              )}
              {removeVisible && (
                <button onClick={removeBadge} className="removeBadge">
                  X
                </button>
              )}
            </li>
          ))}
          {/* {!badgeLink && !onClick && badgeData.map((item: any, index: number) => (
              <li key={item} className={`${size && size} ${type && type}`}>
                {item}
                {removeVisible && <button onClick={removeBadge} className='removeBadge'>X</button>}

              </li>
            ))}
            {!badgeLink && onClick && badgeData.map((item: any, index: number) => (
              <li key={item} className={`${size && size} ${type && type}`}>
                
                {removeVisible && <button onClick={removeBadge} className='removeBadge'>X</button>}

              </li>
            ))} */}
        </ul>
      )}
    </div>
  );
};

export default Badge;
